module.exports = __webpack_public_path__ + "img/sdhc.bc380924.png";